export default __webpack_public_path__ + "static/media/SL.c7db4ee9.svg";